import { render, staticRenderFns } from "./infogfdetail.vue?vue&type=template&id=3a770ab2&scoped=true"
import script from "./infogfdetail.vue?vue&type=script&lang=js"
export * from "./infogfdetail.vue?vue&type=script&lang=js"
import style0 from "./infogfdetail.vue?vue&type=style&index=0&id=3a770ab2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a770ab2",
  null
  
)

export default component.exports